import { render, staticRenderFns } from "./parts-splitter.vue?vue&type=template&id=409bc281&"
import script from "./parts-splitter.vue?vue&type=script&lang=js&"
export * from "./parts-splitter.vue?vue&type=script&lang=js&"
import style0 from "./parts-splitter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DynamicImg: require('/opt/build/repo/storefront/components/legacy/global/dynamic-img.vue').default,SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default,SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default})
